import React from 'react'
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
export default function ErrorPage () {
   
  return (
    <div>
 <Helmet>
        <title>Sorry, Page Not Found - 404 Error</title>
        <meta property="og:title" content="Sorry, Page Not Found - 404 Error"/>
        <meta property="og:site_name" content="Desire Store"/>
        <meta property="og:url" content="https://desirestore.online/404"/>
        <meta property="og:description" content="Our 404 error page indicates that the requested page cannot be found. This can occur for a variety of reasons, including mistyped URLs or deleted pages. We apologize for any inconvenience and suggest that you try navigating to another page on our site using the menu or search bar. Alternatively, you can contact our support team for assistance."/>
        <meta property="og:type" content="website"/>
        <meta property="og:image" content="og-images/og-home.png"/>
        <link rel="canonical" href="https://desireStore.online/404" />

        <meta name="title" content="Sorry, Page Not Found - 404 Error"/>
        <meta name="description" data-rh="true" content="Our 404 error page indicates that the requested page cannot be found. This can occur for a variety of reasons, including mistyped URLs or deleted pages. We apologize for any inconvenience and suggest that you try navigating to another page on our site using the menu or search bar. Alternatively, you can contact our support team for assistance."/>
        <meta name="keywords" content="404 error, page not found, mistyped URLs, deleted pages, navigation, search bar, support."/>
      </Helmet>
       <div className="page_404">
       <div className="container">
           <div className="row">
               <div className="col-sm-12">
                   <div className="col-sm-10 col-sm-offset-1 text-center">
                       <div className="four_zero_four_bg">
                           <h1 className="text-center">404</h1>
                       </div>
                       <div className="content_box_404">
                           <h3 className="h2">Monster strikes again</h3>
                           <p>The website monster ate your page! </p>
                           <p>Oops! Page not found</p>
                           <Link to={"/"}>Go home</Link>
                       </div>
                   </div>
               </div>
           </div>
       </div>
   </div>
    </div>
  )
}
